import { Activity } from '../api/types';
import { RUN_TYPES } from './format';

/** True for the run activity types (road, trail and treadmill). Pace and run trends use only these. */
export function isRun(activity: Activity): boolean {
  return activity.activityType !== null && RUN_TYPES.includes(activity.activityType);
}
